import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Sparkle } from './Sparkle';
import { LazyCalendlyModal, LazyGuideModal } from './LazyModals';

/**
 * Abschluss-Sektion mit zwei klaren nächsten Schritten:
 * kostenlosen Guide sichern oder ein Kennenlerngespräch buchen.
 */
export function NextStep() {
  const [guideOpen, setGuideOpen] = useState(false);
  const [calendlyOpen, setCalendlyOpen] = useState(false);
  const [calendlyPreload, setCalendlyPreload] = useState(false);
  return <section id="guide" className="relative w-full bg-cream px-4 py-10 sm:px-6 sm:py-12" data-id="element-354" data-mp="34qmnbq4l2tuu">
      <span aria-hidden="true" className="gold-glitter-layer-static" data-id="element-355" data-mp="2qzhup7zmv1u0" />
      <span aria-hidden="true" className="gold-glitter-extra" data-id="element-356" data-mp="2qx5ep0dfr1jl" />

      <div className="relative z-10 mx-auto max-w-[1100px]" data-id="element-357" data-mp="2vwi1xm87yamp">
        <div className="text-center" data-id="element-358" data-mp="3jn3z2igoqahx">
          <span className="mb-4 block text-xs font-semibold uppercase tracking-[0.25em] text-neutral-700" data-id="element-359" data-mp="3jm2n8bruhjz5">
            So geht’s weiter
          </span>
          <div className="relative inline-block" data-id="element-360" data-mp="1zwcury4w4fuz">
            <Sparkle className="animate-sparkle -left-6 top-1 h-5 w-5 sm:-left-9 sm:h-7 sm:w-7" data-id="element-361" data-mp="1zx5xmo0qal7u" />
            <Sparkle className="animate-sparkle-fast -right-5 bottom-1 h-4 w-4 sm:-right-8 sm:h-5 sm:w-5" data-id="element-362" data-mp="1vwlvf61asreu" />
            <h2 className="font-display text-2xl font-extrabold uppercase leading-[1.15] text-hot-500 sm:text-3xl lg:text-4xl" data-id="element-363" data-mp="29nqrjy5gj1kf">
              Dein nächster Schritt
            </h2>
          </div>
          <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-neutral-700" data-id="element-364" data-mp="2jisgotzqg3n0">
            Hol dir den kostenlosen Guide und erfahre in Ruhe, wie dein Einstieg als
            Hot Sales Girl aussehen kann – oder buch dir direkt ein kostenloses und
            unverbindliches Gespräch. Gemeinsam schauen wir, wo du aktuell stehst und wie wir dich
            auf deinem Weg zum Hot Sales Girl begleiten können.
          </p>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-3 sm:gap-6" data-id="element-365" data-mp="t8pfefdv0jdv">
          <motion.button type="button" onClick={() => setGuideOpen(true)} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.45,
          delay: 0.1
        }} className="group relative flex min-h-[330px] flex-col justify-end overflow-hidden rounded-2xl bg-gradient-to-b from-hot-50 to-[#eeb4d0] p-4 text-left shadow-xl min-[390px]:max-sm:justify-start min-[390px]:max-sm:pt-14 max-[389px]:justify-start md:max-lg:justify-start transition-transform duration-200 ease-out hover:-translate-y-1 sm:min-h-[380px] sm:rounded-[2rem] sm:p-10" data-id="element-366" data-mp="tak2o0clsnl4">
            {/* Gleicher Glitter wie im Rest der Seite, nur drei Punkte */}
            <span aria-hidden="true" className="gold-glitter-sparse" data-id="element-367" data-mp="3qxe9zdoipzol" />

            <span className="relative text-[9px] font-semibold uppercase tracking-[0.2em] text-hot-600 sm:text-xs sm:tracking-[0.25em]" data-id="element-368" data-mp="3v0u2pyxgvfw0">
              Hol dir den
            </span>
            <span className="font-heading relative mt-2 block text-xl font-bold leading-tight text-neutral-900 sm:mt-3 sm:text-4xl" data-id="element-369" data-mp="1oc1xf7uiddr6">
              Kostenlosen Guide
            </span>
            <span className="relative mb-[1.625em] mt-2 block text-[11px] leading-relaxed text-neutral-700 max-[389px]:mb-0 min-[390px]:max-sm:mb-0 sm:mb-0 sm:mt-4 sm:text-sm" data-id="element-370" data-mp="1fakhpql0je30">
              Dein 15-seitiger Guide für deinen Einstieg in High Ticket Sales: Erfahre, wie du als
              Hot Sales Girl ortsunabhängig arbeiten und dir Schritt für Schritt ein attraktives
              Einkommen aufbauen kannst.
            </span>
            <span className="btn-gold-shiny relative mt-4 inline-flex items-center justify-center rounded-full px-3 py-2 text-center text-[11px] font-semibold leading-tight min-[390px]:max-sm:mt-auto sm:mt-8 sm:w-fit sm:px-6 sm:py-2.5 sm:text-sm max-[389px]:mt-auto md:max-lg:mt-auto" data-id="element-371" data-mp="1y8ohhuf0g0s5">
              Guide kostenlos sichern
            </span>
          </motion.button>

          <motion.button type="button" onClick={() => setCalendlyOpen(true)} onPointerEnter={() => setCalendlyPreload(true)} onPointerDown={() => setCalendlyPreload(true)} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} onViewportEnter={() => setCalendlyPreload(true)} transition={{
          duration: 0.45,
          delay: 0.2
        }} className="group flex min-h-[330px] flex-col justify-end rounded-2xl bg-gradient-to-b from-cream to-gold/50 p-4 text-left shadow-xl min-[390px]:max-sm:justify-start min-[390px]:max-sm:pt-14 max-[389px]:justify-start md:max-lg:justify-start transition-transform duration-200 ease-out hover:-translate-y-1 sm:min-h-[380px] sm:rounded-[2rem] sm:p-10" data-id="element-372" data-mp="25k1g9q3o6mix">
            <span className="text-[9px] font-semibold uppercase tracking-[0.2em] text-gold-dark sm:text-xs sm:tracking-[0.25em]" data-id="element-373" data-mp="385bqaljv8n3s">
              Buch
            </span>
            <span className="font-heading mt-2 block text-xl font-bold leading-tight text-neutral-900 sm:mt-3 sm:text-4xl" data-id="element-374" data-mp="3mb3nkx62fj4p">
              Deinen Termin
            </span>
            <span className="mt-2 block text-[11px] leading-relaxed text-neutral-700 sm:mt-4 sm:text-sm" data-id="element-375" data-mp="3w1ot74k5pnx4">
              Lern uns in einem kostenlosen und unverbindlichen Gespräch kennen. Gemeinsam schauen
              wir, wo du aktuell stehst und wie dein persönlicher Weg in High Ticket Sales aussehen
              kann.
            </span>
            <span className="btn-gold-shiny mt-4 inline-flex items-center justify-center rounded-full px-3 py-2 text-center text-[11px] font-semibold leading-tight min-[390px]:max-sm:mt-auto sm:mt-8 sm:w-fit sm:px-6 sm:py-2.5 sm:text-sm max-[389px]:mt-auto md:max-lg:mt-auto" data-id="element-376" data-mp="2zd0n96lptr42">
              Kostenloses Gespräch buchen
            </span>
          </motion.button>
        </div>
      </div>

      <LazyGuideModal open={guideOpen} onClose={() => setGuideOpen(false)} data-id="element-377" data-mp="nl3k7nriyuu0" />
      <LazyCalendlyModal open={calendlyOpen} preload={calendlyPreload} onClose={() => setCalendlyOpen(false)} data-id="element-378" data-mp="vndvfcyy8nj0" />
    </section>;
}